<template>
  <div class="py-3">
    <eg-b-alert show variant="secondary">
      {{ $t("imports.needSomeHelpStep") }}
      <a
        href="https://egcdn.nyc3.cdn.digitaloceanspaces.com/videos/EssayGrader_CanvasTokenCreation.mp4"
        target="_blank"
        >{{ $t("imports.watchDemoVideoStep") }}</a
      >
    </eg-b-alert>
    <canvas-integration-form v-model="formData" />
  </div>
</template>

<script>
import CanvasIntegrationForm from "@/views/dashboard/workspace-integration/canvas/canvas-integration-form.vue";

export default {
  components: { CanvasIntegrationForm },
  props: {
    value: {
      type: Object,
      default: () => ({ canvasUrl: "", canvasToken: "" }),
    },
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
